import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

/** @namespace Pwa/Component/HeadIncludes/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/HeadIncludes/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    headIncludes: state.ConfigReducer.head_includes,
});

/** @namespace Pwa/Component/HeadIncludes/Container */
export class HeadIncludesContainer extends PureComponent {
    componentDidMount() {
        this.initHeadIncludesJS();
    }

    initHeadIncludesJS() {
        const { headIncludes } = this.props;

        if (headIncludes) {
            const regex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
            const matches = headIncludes.match(regex);

            if (matches && matches?.length) {
                matches.forEach((match) => {
                    const scriptTag = document.createElement('script');

                    const textScript = match
                        .replaceAll('<script type="text/javascript">', '')
                        .replaceAll('</script>', '')
                        .replaceAll('<script>', '');

                    const scriptText = document.createTextNode(textScript);
                    scriptTag.appendChild(scriptText);

                    document.head.appendChild(scriptTag);
                });
            }
        }
    }

    render() {
        return null;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeadIncludesContainer));
